import { useEffect, useState } from "react";
import { fetchCurrentBalances } from "../../api/balances";
import xlsxIcon from "../../images/icons/xlsx_icon.svg";
import downloadIcon from "../../images/icons/download_dark.svg";
import loaderIcon from "../../images/icons/loader.svg";

const Balances = () => {
  const [documents, setDocuments] = useState([]);
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    const loadDocuments = async () => {
      try {
        const response = await fetchCurrentBalances();

        if (response?.result?.length) {
          const latest = response.result.sort(
            (a, b) => new Date(b.updatedAt.date) - new Date(a.updatedAt.date)
          )[0];

          const formattedDate = new Date(
            latest.updatedAt.date
          ).toLocaleDateString("ru-RU");

          setDocuments([
            {
              title: `Складские остатки AQUASTRONG ${formattedDate} Excel`,
              path: latest.filename,
            },
          ]);
        } else {
          setDocuments([]);
        }

        setStatus("success");
      } catch (e) {
        // console.error("Ошибка при загрузке:", e);
        setDocuments([]);
        setStatus("error");
      }
    };

    loadDocuments();
  }, []);

  const openFile = (path) => {
    if (!path) return;

    const link = document.createElement("a");
    link.href = path;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  if (status === "loading") {
    return (
      <div className="loader">
        <img src={loaderIcon} alt="loader" />
      </div>
    );
  }

  return (
    <div className="balances">
      <div className="page-width flex-column">
        {documents.length ? (
          documents.map((item, index) => (
            <div
              key={index}
              className="document-container flex-row flex-between w-100 gap-4x"
            >
              <img src={xlsxIcon} alt="xlsx file" />
              <h3 className="w-100 pointer" onClick={() => openFile(item.path)}>
                {item.title}
              </h3>

              <img
                className="download pointer"
                alt="download"
                onClick={() => openFile(item.path)}
                src={downloadIcon}
              />
            </div>
          ))
        ) : (
          <h3>Ничего не найдено</h3>
        )}
      </div>
    </div>
  );
};

export default Balances;
